/** Fire-and-forget click tracking for affiliate links */
export function trackAffiliateClick(url: string, label: string, publicKey: string) {
  try {
    const provider = url.includes('booking.com') ? 'Booking.com'
      : url.includes('rentalcars.com') ? 'RentalCars'
      : url.includes('getyourguide.com') ? 'GetYourGuide'
      : url.includes('romitravel.com') ? 'RomiTravel'
      : 'other'
    const category = provider === 'Booking.com' ? 'hotel'
      : provider === 'RentalCars' ? 'car'
      : provider === 'GetYourGuide' ? 'tour'
      : provider === 'RomiTravel' ? 'article'
      : 'other'

    const dashboardBase = 'https://voice-bot-admin-dashboard.vercel.app'

    fetch(`${dashboardBase}/api/affiliate-clicks`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        publicKey,
        linkUrl: url,
        linkLabel: label,
        articleTitle: label,
        provider,
        category,
      }),
    }).catch(() => { /* silent fail */ })
  } catch {
    // Silent fail
  }
}
